import { Dispatch, FC, SetStateAction } from 'react';
import * as React from 'react';

import Chip from '@crehana/ui/dist/Chip';

import { GetAvailableResourceCategories_categoriesForResources as CategoryType } from '../../../graphql/types/GetAvailableResourceCategories';

interface CategoryListProps {
  categories: CategoryType[];
  selectedCategories: string[];
  setSelectedCategories: Dispatch<SetStateAction<string[]>>;
}

const CategoryList: FC<React.PropsWithChildren<CategoryListProps>> = ({
  categories,
  selectedCategories,
  setSelectedCategories,
}) => (
  <div className="sm:mt-20 sm:pt-8">
    {categories.map(category => (
      <Chip
        key={category.value}
        label={category.label}
        className="mr-16 mb-16"
        active={selectedCategories.includes(category.slug)}
        onClick={() => {
          if (selectedCategories.includes(category.slug)) {
            setSelectedCategories(
              selectedCategories.filter(el => el !== category.slug),
            );
          } else {
            setSelectedCategories([...selectedCategories, category.slug]);
          }
        }}
      />
    ))}
  </div>
);

export default CategoryList;
